export const FETCH_DATA_REQUEST = '@feedbackData/FETCH_DATA_REQUEST';
export const FETCH_DATA_SUCCESS = '@feedbackData/FETCH_DATA_SUCCESS';
export const FETCH_DATA_FAILURE = '@feedbackData/FETCH_DATA_FAILURE';

export const SEND_DATA_REQUEST = '@feedbackData/SEND_DATA_REQUEST';
export const SEND_DATA_SUCCESS = '@feedbackData/SEND_DATA_SUCCESS';
export const SEND_DATA_FAILURE = '@feedbackData/SEND_DATA_FAILURE';

export const RESET_FEEDBACK = '@feedbackData/RESET_FEEDBACK';
